import { useState, useRef, useEffect } from 'react';

const useOutsideClick = (props) => {
    const [popupView, setPopupView] = useState(props);
    const handlePopupView = () => {
        setPopupView(!popupView);
    };
    const elmRef = useRef(null);
    const handleClickOutside = (event) => {
        if (elmRef.current && !elmRef.current.contains(event.target)) {
            setPopupView(!popupView);
        }
    };
    useEffect(() => {
        window.addEventListener("mousedown", handleClickOutside);
        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, [popupView]);
    return [popupView, elmRef, handlePopupView];
};

export { useOutsideClick };
//# sourceMappingURL=useOutsideClick.js.map
